module.exports = __webpack_public_path__ + "img/item1.922d90ec.jpg";